import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';

export default {
  attributeName: 'appManualProvider',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: true,
  canRemove: true,
  editURL: '',
  emptyMessage: "You don't have tokens, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'token',
      label: 'Token',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Token string',
      default: '',
      canEdit: false,
      canCreate: true,
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'used',
      label: 'Transactions',
      width: '12rem',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      helpText: 'Number of times that the token was used',
      default: '',
      canEdit: false,
      canCreate: false,
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'failUsed',
      label: 'Fail Transactions',
      width: '14rem',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      helpText: 'Number of times that the token was used as a fail',
      default: '',
      canEdit: false,
      canCreate: false,
      canOrder: true,
      canFilter: true,
    },
    {
      attributeName: 'link',
      label: 'Kibana Link',
      type: FormInputTypes.LINK,
      icon: IconType.LINK,
      width: '10rem',
      helpText: 'Kibana external link with the devices associated with the token attribute of this row.',
    },
    {
      attributeName: 'revokeToken',
      label: 'Revoke',
      type: FormInputTypes.BUTTON,
      helpText: 'To revoke all transactions of this token',
      width: '7rem',
    },
  ],
};
